module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMyIDMyIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cG9seWdvbiBmaWxsPSIjNGY5NWQwIiBwb2ludHM9IjEyLjY1MSw1LjE3MSAxMS45NTYsNC40NTIgMCwxNiAxMS45NTYsMjcuNTQ4IDEyLjY1MSwyNi44MjkgMS45NTcsMTYuNSAzMi4xODksMTYuNSAzMi4xODksMTUuNSAxLjk1NywxNS41ICI+PC9wb2x5Z29uPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/icons/arrow-left.svg
// module id = 578
// module chunks = 107818501498521